




































import {Component, Vue} from "vue-property-decorator";
import formatDate from '@/filters/DateFormatter';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import {Slot} from '@/model/collection/Slot';
import {Drive} from '@/model/Drive';
import {Inject} from "vue-typedi";
import {SupportService} from "@/services/SupportService";
import {Support, SupportStatuses} from "@/model/support/Support";
import {DriveService} from "@/services/DriveService";

@Component({
  filters: {formatDate, formatStoreLabel}
})
export default class DropOffSlotSelection extends Vue {

  @Inject()
  supportService!: SupportService;
  @Inject()
  driveService!: DriveService;

  allDrives: Drive[] = [];
  allSlots: Slot[] = [];
  allCollectedSupports: Support[] = [];
  isInitialized: Boolean = false;

  selectedDrive: Drive = null;
  selectedSlot: Slot = null;

  mounted() {
    const storeId = sessionStorage.getItem('storeId');
    this.fetchDrives(storeId);
    this.fetchSlots();
    this.isInitialized = true;
  }

  private fetchDrives(storeId: string) {
    this.driveService.getDrivesByStoreId(storeId).then((res: Drive[]) => {
      this.allDrives = res.filter(drive => !drive.relay);
      this.initDriveSelection();
    })
  }

  private fetchSlots() {
    this.supportService.getCollectedSupports().then((res: Support[]) => {
      if (!res) {
        this.allCollectedSupports = [];
        this.allSlots = [];
        return;
      }

      this.allCollectedSupports = res;
      const grouped = new Map<number, Slot>();

      this.allCollectedSupports
        .forEach(support => {
          const date = new Date(support.collectionSlot);
          const key = date.getTime();

          if (!grouped.has(key)) {
            grouped.set(key, {
              dueDate: new Date(date),
              driveIds: []
            });
          }

          grouped.get(key)!.driveIds.push(support.driveId);
        });

      this.allSlots = Array.from(grouped.values()).sort((a, b) => a.dueDate.getTime() - b.dueDate.getTime());
    });
  }


  private initDriveSelection(): void {
    if (this.allDrives == null || this.allDrives.length > 1) {
      return;
    }

    this.selectedDrive = this.allDrives[0];
  }

  onSelectedDriveChange(): void {
    this.selectedSlot = null;
  }

  onStartDropOff(): void {
    const supportsToDropOff = this.allCollectedSupports.filter(support =>
      support.driveId === this.selectedDrive.driveId &&
      new Date(support.collectionSlot).getTime() ===
      this.selectedSlot.dueDate.getTime()
    );

    this.$emit('selectionchange', {
      drive: this.selectedDrive,
      slot: this.selectedSlot,
      supports: supportsToDropOff
    });
  }

  get filteredSlots(): Slot[] {
    if (!this.selectedDrive) {
      return [];
    }

    return this.allSlots.filter(slot => slot.driveIds.includes(this.selectedDrive.driveId));
  }

  get hasSlots(): Boolean {
    return this.filteredSlots != null && this.filteredSlots.length > 0;
  }

  get canStartDropOff(): Boolean {
    return this.selectedDrive != null && this.selectedSlot != null;
  }
}
